import { makeApi } from "@zodios/core";
import { z } from "zod";

import { applyPersonalizationRequestSchema } from "@/types/backoffice/dto/personalization/apply-personalization-request.ts";
import { personalizationHistoryDtoSchema } from "@/types/backoffice/dto/personalization/personalization-history-dto.ts";

export const backofficePersonalizationApi = makeApi([
  {
    method: "post",
    path: "/site/:siteId",
    alias: "applyPersonalizationInSite",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
      {
        type: "Body",
        name: "body",
        schema: applyPersonalizationRequestSchema,
      },
    ],
    response: z.any(),
  },
  {
    method: "get",
    path: "/site/:siteId/history",
    alias: "findPersonalizationHistory",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
    ],
    response: z.array(personalizationHistoryDtoSchema),
  },
  {
    method: "delete",
    path: "/site/:siteId/personalization/:personalizationId",
    alias: "cancelPersonalizationById",
    response: z.any(),
  },
]);
